import { IconWrapper } from '../runtime';
export default IconWrapper('label', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M7.82084 14.1894C7.23505 14.7751 6.28531 14.7751 5.69952 14.1894L1.81043 10.3003C1.22465 9.71448 1.22465 8.76473 1.81043 8.17895L8.18407 1.80531C8.46538 1.524 8.84691 1.36597 9.24473 1.36597H14.3338C14.4995 1.36597 14.6338 1.50028 14.6338 1.66597V6.75505C14.6338 7.15288 14.4758 7.53441 14.1945 7.81571L7.82084 14.1894Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  }), h("circle", {
    "attrs": {
      "cx": "10.3701",
      "cy": "5.63133",
      "r": "1.5",
      "transform": "rotate(45 10.3701 5.63133)",
      "fill": props.colors[0],
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});